import integrationsApi from '@/api/integrations';
import {mutationTypes} from '@/store/modules/integrations/mutations';

export const actionsTypes = {
  translateIds: '[integrations] translate ids',
  getReportParams: '[integrations] get report params',
};

const actions = {
  [actionsTypes.translateIds](context, data) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.translateIdsStart);
      integrationsApi
        .translateIds(data)
        .then((response) => {
          context.commit(mutationTypes.translateIdsSuccess);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.translateIdsFailure);
          reject(result);
        });
    });
  },
  [actionsTypes.getReportParams](context, accGuid) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getReportParamsStart);
      integrationsApi
        .getReportParams(accGuid)
        .then((response) => {
          context.commit(mutationTypes.getReportParamsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getReportParamsFailure);
          reject(result);
        });
    });
  },
};

export default actions;
